exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alerts-history-page-container{width:100%;padding:20px;background-color:#fff}#alerts-history-page-container #alerts-history-title{display:none;width:100%;text-align:left;font-size:26px;padding-left:10px}#alerts-history-page-container .alerts-history-list{padding:10px;width:100%}#alerts-history-page-container .alerts-history-list .ant-table-row{text-align:center}#alerts-history-page-container .alerts-history-list .alerts-history-list-element{width:100%;font-size:26px;border-bottom:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/alerts/history.scss
// module id = 2200
// module chunks = 43